import axios from 'api/axios'

const registerPhoneNumber = async (clientId: string, pin: string) => {
	const { data } = await axios.post(
		`/v1/tsp/meta/waba/phone-number/registration?clientId=${clientId}`,
		{ pin }
	)
	return data
}

export default registerPhoneNumber
